module.exports = __webpack_public_path__ + "a92b2f83cd3287d0f3b22444eb003649.jpg";


//////////////////
// WEBPACK FOOTER
// ./pages/news/2/kristoffer_karlsson_news.jpg
// module id = 243
// module chunks = 0